import React from 'react'
import { Icon } from "@iconify/react";
const Header = () => {
  return (
    <header className="header">
      <h1>
        <Icon icon="simple-icons:nasa" />
        Natural Hazards Viewer (Powered by Nasa)
      </h1>
    </header>
  );
}

export default Header